import { useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "react-redux-loading-bar";

const CBFileUploader = ({
    fieldName,
    value,
    setFieldValue,
    label = 'Select Excel File',
    removeFileDiabled = false,
    constraints = {
        validTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'application/vnd.ms-excel' // .xls
        ],
        maxSizeMB: 100
    }
}) => {
    const dispatch = useDispatch();
    const [error, setError] = useState('');

    const validateFile = (file) => {
        const { validTypes, maxSizeMB } = constraints;

        if (!validTypes.includes(file.type)) {
            return 'Only .xlsx or .xls files are allowed.';
        }

        if (file.size > maxSizeMB * 1024 * 1024) {
            return `File size must be less than ${maxSizeMB}MB.`;
        }

        return null;
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setError('');
        dispatch(showLoading());

        const validationError = validateFile(file);
        if (validationError) {
            setError(validationError);
            dispatch(hideLoading());
            return;
        }

        // setFieldValue(fieldName, file); // store file object

        const timestamp = new Date().toISOString().replace(/[-:.]/g, '');
        const fileExtension = file.name.split('.').pop();
        const fileNameWithoutExt = file.name.substring(0, file.name.lastIndexOf('.'));
        const newFileName = `${fileNameWithoutExt}_${timestamp}.${fileExtension}`;

        const renamedFile = new File([file], newFileName, {
            type: file.type,
            lastModified: file.lastModified,
        });
        setFieldValue(fieldName, renamedFile); // store file object
        dispatch(hideLoading());
    };

    const removeFile = () => {
        setFieldValue(fieldName, null);
        setError('');
    };

    return (
        <div className="form-group">
            {!value ? (
                <>
                    <div>{label}</div>
                    <input
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                    // className="form-control"
                    // aria-describedby={`${fieldName}-error`}
                    />
                </>
            ) : (
                <>
                    <div className="mt-2">
                        <strong>Selected File:</strong> {value.name}
                    </div>
                    <div className="mt-3 d-flex justify-content-center">
                        <Button onClick={removeFile} className="btn-sm" disabled={removeFileDiabled} style={{ backgroundColor: '#ea5f2d' }}>
                            Remove
                        </Button>
                    </div>
                </>
            )}

            {error && <div className="text-danger mt-2">{error}</div>}
        </div>
    );
};

export default CBFileUploader;
